<template>
  <div class="UiInputHtmlTiptap">
    <EditorToolbar
      class="UiInputHtmlTiptap__toolbar"
      v-if="editor"
      :editor="editor"
    />
    <editor-content
      class="UiInputHtmlTiptap__content"
      :editor="editor"
    />
  </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit'; // Extension basica de tip-tap
import { HTMLSpec } from './html-spec'; // Extension para HTML generico

import EditorToolbar from './EditorToolbar.vue';

export default {
  components: {
    EditorContent,
    EditorToolbar,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editor: null,
    };
  },

  watch: {
    value(value) {
      const isSame = this.editor.getHTML() === value;
      if (isSame) {
        return;
      }

      this.editor.commands.setContent(value, false);
    },
  },

  mounted() {
    this.editor = new Editor({
      content: this.value,
      extensions: [
        StarterKit.configure({
          heading: false,
          paragraph: false
        }),
        HTMLSpec,
      ],
      onUpdate: () => {
        this.$emit('input', this.editor.getHTML());
      },
      autofocus: true,
    });
  },

  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>

<style lang="scss">
.UiInputHtmlTiptap {
  border: 1px solid #dcdcdc;

  textarea,
  div[contenteditable] {
    display: block;
    box-sizing: border-box;
    height: 500px;
    resize: vertical;
    overflow: auto;
    outline: none;
  }

  /* Link styles */
  a {
    color: -webkit-link;
    text-decoration: underline;

    &:hover {
      background: #bfe6ff;
    }
  }

  &__content {
    padding: 0.25rem;

    img {
      max-width: 100%;
      // height: auto;

      &.ProseMirror-selectednode {
        // outline: 3px solid #68cef8;
        outline: 3px solid greenyellow;
      }
    }
  }
}
</style>